import React, { useEffect, useState } from 'react';
import { Menu, X, Phone, Calendar } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#'
  }, {
    name: 'Residential',
    href: '#residential'
  }, {
    name: 'Commercial',
    href: '#commercial'
  }, {
    name: 'Emergency',
    href: '#emergency',
    className: 'text-red-600 font-bold'
  }, {
    name: 'Air Conditioning',
    href: '#aircon'
  }, {
    name: 'About',
    href: '#about'
  }];
  return <header className={`sticky top-0 z-50 w-full transition-all duration-300 bg-white ${isScrolled ? 'shadow-md py-3' : 'py-5'}`} data-id="element-249">
      {/* Subtle top green line on scroll */}
      <div className={`absolute top-0 left-0 right-0 h-[2px] bg-orange transition-opacity duration-300 ${isScrolled ? 'opacity-100' : 'opacity-0'}`} data-id="element-250"></div>

      <div className="max-w-7xl mx-auto px-4 flex justify-between items-center" data-id="element-251">
        <a href="#" className="flex-shrink-0" data-id="element-252">
          <img src="https://cdn.magicpatterns.com/uploads/keXDJJ6XdrR4HdR9pRaeSp/pasted-image.png" alt="Completely Electrical" className="h-10 md:h-12" data-id="element-253" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden xl:flex items-center gap-5" data-id="element-254">
          {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-semibold hover:text-orange transition-colors ${link.className || 'text-navy'}`} data-id="element-255">
              {link.name}
            </a>)}
        </nav>

        <div className="hidden lg:flex items-center gap-6" data-id="element-256">
          <a href="tel:0418381988" className="text-navy font-extrabold text-lg hover:text-orange transition-colors flex items-center gap-2" data-id="element-257">
            <Phone className="w-5 h-5 text-orange" data-id="element-258" />
            0418 381 988
          </a>
          <a href="#quote" className="bg-orange hover:bg-orange-600 text-white px-6 py-3 rounded-lg font-bold flex items-center gap-2 transition-all shadow-sm hover:shadow-md hover:-translate-y-0.5" data-id="element-259">
            <Calendar className="w-4 h-4" data-id="element-260" />
            Get Free Quote
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden text-navy p-2 hover:bg-gray-50 rounded-md transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-261">
          {isMobileMenuOpen ? <X className="w-7 h-7" data-id="element-262" /> : <Menu className="w-7 h-7" data-id="element-263" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isMobileMenuOpen && <div className="lg:hidden absolute top-full left-0 w-full bg-white shadow-xl border-t border-gray-100 py-4 px-4 flex flex-col gap-2" data-id="element-264">
          {navLinks.map(link => <a key={link.name} href={link.href} className={`text-base font-bold py-3 px-4 rounded-lg hover:bg-gray-50 ${link.className || 'text-navy'}`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-265">
              {link.name}
            </a>)}
          <div className="h-px bg-gray-100 my-2" data-id="element-266"></div>
          <a href="tel:0418381988" className="bg-navy text-white px-6 py-4 rounded-lg font-bold flex items-center justify-center gap-2 mt-2" data-id="element-267">
            <Phone className="w-5 h-5" data-id="element-268" />
            Call 0418 381 988
          </a>
          <a href="#quote" className="bg-orange text-white px-6 py-4 rounded-lg font-bold flex items-center justify-center gap-2 mt-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-269">
            <Calendar className="w-5 h-5" data-id="element-270" />
            Get Free Quote
          </a>
        </div>}
    </header>;
}